export enum GoalKey {
  PROVIDE_MINOR_BENEFICIARIES = 'provide_minor_beneficiaries',
  COST_EFFECTIVE_SIMPLE_WILL = 'cost_effective_simple_will',
  HIGHLY_DETAILED_INSTRUCTIONS = 'highly_detailed_instructions',
  AVOID_FAMILY_CONFLICTS = 'avoid_family_conflicts',
  PROTECT_BENEFICIARIES = 'protect_beneficiaries',
  REDUCE_LIABILITIES = 'reduce_liabilities',
  SUPPORT_CREATING_WILL = 'support_creating_will',
  MULTIDISCIPLINARY_EXPERTS = 'multidisciplinary_experts',
  PROFESSIONAL_TO_SETTLE_ESTATE = 'professional_to_settle_estate'
}
